import { IApiDataResponse, IApiItemsResponse, ITagItem } from '../models/interfaces';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import { DutyTypeCode } from '../models/types';

export const BACKGROUND_COLOR = {
  rate: '#dfebf9',
  regular: '#c7ffdd',
  irregular: '#fff3a8',
  overtime: '#008000',
};

export function tagStyle(tag: ITagItem): Object | null {
  return tag.color ? { border: `1px solid ${tag.color}`, color: `${tag.color}` } : null;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getElementData(element: unknown[], column: string, defaultValue?: any): any {
  return (
    column.split('.').reduce((data, path) => {
      return (data || {})[path];
    }, element) || defaultValue
  );
}

export function extractData<T>(response: IApiDataResponse<T>): T {
  return response.data!;
}

export function extractItems<T>(response: IApiItemsResponse<T>): T[] {
  return response.items!;
}

export function getStartOfWeek(date: Date): Date {
  return startOfWeek(date, { weekStartsOn: 1 });
}

export function getEndOfWeek(date: Date): Date {
  return endOfWeek(date, { weekStartsOn: 1 });
}

export function selectBackground(rate: number, dutyTypeCode: DutyTypeCode): string {
  if (rate > 1) {
    return BACKGROUND_COLOR.rate;
  } else if (dutyTypeCode === DutyTypeCode.overtime) {
    return BACKGROUND_COLOR.overtime;
  } else if (dutyTypeCode === DutyTypeCode.regular) {
    return BACKGROUND_COLOR.regular;
  } else {
    return BACKGROUND_COLOR.irregular;
  }
}
